module.exports = __webpack_public_path__ + "37800d079b50538452f4dd630d8fb70a.pdf";